import { createUseStyles } from '@pe-libs/react-components/build/theme';

type PropsType = { headerUrlFull: string; headerUrlMedium: string };

const useStyles = createUseStyles(
  'default-landing-heroImage',
  ({ breakpoints: { up }, palette: { common, primary } }) => ({
    heroContainer: {
      backgroundImage: (props: PropsType) => `url(${props.headerUrlFull})`,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'top center',
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'center',
      width: '100%',
      height: '216px',
    },
    titleContainer: {
      position: 'relative',
      transform: 'translateY(50%)',
      display: 'inline-flex',
      justifyContent: 'center',
      flexDirection: 'column',
    },
    title: {
      background: primary.main,
      padding: '0.5rem 1.875rem 1rem',
      color: common.white,
      fontWeight: 600,
      margin: '0 1rem 0',
      fontSize: '2.125rem',
      lineHeight: 1.2,
      letterSpacing: '0.35px',
      textAlign: 'center',

      [up('lg')]: {
        padding: '0.625rem 0.75rem 0.875rem',
        fontSize: '3.375rem',
        letterSpacing: '0.18px',
      },
    },
    description: {
      position: 'absolute',
      display: 'inline-block',
      backgroundColor: primary.dark,
      color: common.white,
      padding: '0.375rem 0.75rem',
      transform: 'translate(0, 85%)',
      left: 0,
      margin: '-0.625rem 1.8rem 0',
      bottom: 0,
      fontSize: '1.125rem',
      lineHeight: 1.33,
      letterSpacing: '0.17px',
      textAlign: 'center',

      [up(674)]: {
        left: '50%',
        whiteSpace: 'nowrap',
        transform: 'translate(-50%, 85%)',
        margin: 0,
      },

      [up('lg')]: {
        fontSize: '1.5rem',
        lineHeight: '1.2rem',
        letterSpacing: '0.25px',
      },
    },
    avatarContainer: {
      width: '165px',
      height: '165px',
      borderRadius: '4px',
      border: '2px solid #fff',
      boxShadow: ' 0 1px 6px 0 rgba(0,0,0,.2)',
      transform: 'translateY(50%)',
    },
  }),
);

export default useStyles;
